import React, { useEffect, useState, useCallback } from 'react';
import './Alunas.css';
import axios from 'axios';
import { 
  FaTimes, 
  FaUser, 
  FaChartPie, 
  FaChartBar, 
  FaClipboardList,
  FaSearch,
  FaFilter,
  FaSort,
  FaCheckSquare,
  FaSquare,
  FaEdit,
  FaTrash,
  FaPlus,
  FaEnvelope,
  FaCheckCircle,
  FaPauseCircle,
  FaStopCircle,
  FaChevronLeft,
  FaChevronRight,
  FaStickyNote
} from 'react-icons/fa';
import { Pie, Bar, Doughnut } from 'react-chartjs-2';
import 'chart.js/auto';

// Componente Modal para exibir detalhes da aluna
const Modal = ({ aluna, onClose, onNoteAdded, onNoteRemoved }) => {
  const [visualizacao, setVisualizacao] = useState('todos');
  const [editandoNota, setEditandoNota] = useState(false);
  const [novaNota, setNovaNota] = useState('');
  const [loading, setLoading] = useState(false);
  
  if (!aluna) return null;
  
  const formatarData = (dataString) => {
    if (!dataString) return 'Não informada';
    const data = new Date(dataString);
    return data.toLocaleDateString('pt-BR') + ' ' + data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  };
  
  const calcularDiasNoPrograma = () => {
    if (!aluna.data_inicio) return 0;
    const dataInicio = new Date(aluna.data_inicio);
    const hoje = new Date();
    const diffTempo = Math.abs(hoje - dataInicio);
    return Math.ceil(diffTempo / (1000 * 60 * 60 * 24));
  };
  
  const diasNoPrograma = calcularDiasNoPrograma();
  const semanas = diasNoPrograma / 7 > 0 ? Math.ceil(diasNoPrograma / 7) : 1;
  
  const diaDaSemana = () => {
    const hoje = new Date();
    const dias = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];
    return dias[hoje.getDay()];
  };
  
  const handleAddNote = async () => {
    if (!novaNota.trim()) return;
    
    setLoading(true);
    try {
      const apiUrl = process.env.REACT_APP_API_URL_USER || 'http://localhost:3031';
      await axios.post(`${apiUrl}/api/users/admin/${aluna._id}/notes`, {
        texto: novaNota,
        criadoPor: 'admin'
      });
      
      setNovaNota('');
      setEditandoNota(false);
      if (onNoteAdded) onNoteAdded();
    } catch (error) {
      console.error('Erro ao adicionar nota:', error);
      alert('Erro ao adicionar nota');
    } finally {
      setLoading(false);
    }
  };
  
  const handleRemoveNote = async (noteId) => {
    if (!window.confirm('Deseja realmente remover esta nota?')) return;
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL_USER || 'http://localhost:3031';
      await axios.delete(`${apiUrl}/api/users/admin/${aluna._id}/notes/${noteId}`);
      if (onNoteRemoved) onNoteRemoved();
    } catch (error) {
      console.error('Erro ao remover nota:', error);
      alert('Erro ao remover nota');
    }
  };
  
  // Dados para gráficos (mockados)
  const diaAtualData = {
    progresso: { labels: ['Progresso', 'Restante'], datasets: [{ data: [75, 25], backgroundColor: ['#ff9b2f', '#e0e0e0'], borderWidth: 0 }] },
    emocoes: { labels: ['Feliz', 'Calmo', 'Ansioso', 'Triste'], datasets: [{ data: [60, 20, 15, 5], backgroundColor: ['#4caf50', '#2196f3', '#ff9800', '#f44336'], borderWidth: 0 }] },
    consistencia: { labels: ['Completo', 'Incompleto'], datasets: [{ data: [85, 15], backgroundColor: ['#ff9b2f', '#e0e0e0'], borderWidth: 0 }] }
  };
  
  const todosOsDiasData = {
    progresso: { labels: ['Progresso', 'Restante'], datasets: [{ data: [semanas, 12 - semanas > 0 ? 12 - semanas : 0], backgroundColor: ['#ff9b2f', '#e0e0e0'], borderWidth: 0 }] },
    emocoes: { labels: ['Feliz', 'Calmo', 'Ansioso', 'Triste'], datasets: [{ data: [40, 30, 20, 10], backgroundColor: ['#4caf50', '#2196f3', '#ff9800', '#f44336'], borderWidth: 0 }] },
    consistencia: { labels: ['Completo', 'Incompleto'], datasets: [{ data: [75, 25], backgroundColor: ['#ff9b2f', '#e0e0e0'], borderWidth: 0 }] }
  };
  
  const dadosVisualizacao = visualizacao === 'atual' ? diaAtualData : todosOsDiasData;
  
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom', labels: { boxWidth: 12, padding: 15, font: { size: 12 } } },
      tooltip: { callbacks: { label: (context) => `${context.label}: ${context.raw}%` } }
    },
    cutout: '70%'
  };
  
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Perfil da Aluna</h2>
          <button className="modal-close" onClick={onClose}><FaTimes /></button>
        </div>
        
        <div className="modal-body">
          <div className="perfil-header">
            <div className="perfil-avatar">
              <FaUser size={50} />
            </div>
            <div className="perfil-header-info">
              <h3>{aluna.nome || aluna.email}</h3>
              <div className="perfil-status">
                <span className={`status-badge status-${aluna.status || 'ativo'}`}>
                  {aluna.status === 'ativo' && <FaCheckCircle />}
                  {aluna.status === 'pausado' && <FaPauseCircle />}
                  {aluna.status === 'inativo' && <FaStopCircle />}
                  {aluna.status || 'ativo'}
                </span>
                <span className="separador">•</span>
                <span className="dia-semana">{diaDaSemana()}</span>
                <span className="separador">•</span>
                <span className="dia-programa">Dia {diasNoPrograma}</span>
                <span className="separador">•</span>
                <span className="semana-programa">Semana {semanas}</span>
              </div>
            </div>
          </div>
          
          {/* Notas */}
          <div className="notas-section">
            <div className="notas-header">
              <h4><FaStickyNote className="dashboard-icon" /> Notas e Comentários</h4>
              {!editandoNota && (
                <button className="btn-add-note" onClick={() => setEditandoNota(true)}>
                  <FaPlus /> Adicionar Nota
                </button>
              )}
            </div>
            
            {editandoNota && (
              <div className="nota-editor">
                <textarea
                  value={novaNota}
                  onChange={(e) => setNovaNota(e.target.value)}
                  placeholder="Digite sua nota aqui..."
                  rows={3}
                />
                <div className="nota-editor-actions">
                  <button className="btn-save" onClick={handleAddNote} disabled={loading || !novaNota.trim()}>
                    Salvar
                  </button>
                  <button className="btn-cancel" onClick={() => { setEditandoNota(false); setNovaNota(''); }}>
                    Cancelar
                  </button>
                </div>
              </div>
            )}
            
            <div className="notas-list">
              {aluna.notas && Array.isArray(aluna.notas) && aluna.notas.length > 0 ? (
                aluna.notas.map((nota, idx) => (
                  <div key={idx} className="nota-item">
                    <div className="nota-content">
                      <p>{nota.texto}</p>
                      <span className="nota-meta">
                        Por {nota.criadoPor || 'admin'} em {formatarData(nota.dataCriacao)}
                      </span>
                    </div>
                    <button className="btn-remove-note" onClick={() => handleRemoveNote(nota._id)}>
                      <FaTrash />
                    </button>
                  </div>
                ))
              ) : (
                <p className="notas-empty">Nenhuma nota adicionada ainda.</p>
              )}
            </div>
          </div>
          
          <div className="perfil-info">
            <div className="info-group">
              <h4>Informações Pessoais</h4>
              <p><strong>Email:</strong> {aluna.email}</p>
              <p><strong>Telefone:</strong> {aluna.telefone || 'Não informado'}</p>
              <p><strong>Endereço:</strong> {aluna.endereco || 'Não informado'}</p>
              <p><strong>Data de Nascimento:</strong> {aluna.data_nascimento ? formatarData(aluna.data_nascimento) : 'Não informada'}</p>
              <p><strong>Profissão:</strong> {aluna.profissao || 'Não informada'}</p>
            </div>
            
            <div className="info-group">
              <h4>Informações do Programa</h4>
              <p><strong>Data de Início:</strong> {formatarData(aluna.data_inicio)}</p>
              <p><strong>Dias no Programa:</strong> {diasNoPrograma}</p>
              <p><strong>Semana Atual:</strong> {semanas}</p>
              <p><strong>Peso:</strong> {aluna.peso ? `${aluna.peso} kg` : 'Não informado'}</p>
              <p><strong>Altura:</strong> {aluna.altura ? `${aluna.altura} m` : 'Não informada'}</p>
              <p><strong>IMC:</strong> {aluna.peso && aluna.altura ? (aluna.peso / ((aluna.altura / 100) * (aluna.altura / 100))).toFixed(2) : 'Não calculado'}</p>
            </div>
          </div>

          {(aluna.ultimoLogin || aluna.ultimaAtualizacao) && (
            <div className="info-group historico-info">
              <h4>Histórico de Atividades</h4>
              {aluna.ultimoLogin && <p><strong>Último Login:</strong> {formatarData(aluna.ultimoLogin)}</p>}
              {aluna.ultimaAtualizacao && <p><strong>Última Atualização:</strong> {formatarData(aluna.ultimaAtualizacao)}</p>}
              {aluna.createdAt && <p><strong>Cadastrado em:</strong> {formatarData(aluna.createdAt)}</p>}
            </div>
          )}
          
          <div className="dashboard-header">
            <h4 className="dashboard-title">Dashboards</h4>
            <div className="dashboard-toggle">
              <button className={`toggle-btn ${visualizacao === 'todos' ? 'active' : ''}`} onClick={() => setVisualizacao('todos')}>
                Todos os Dias
              </button>
              <button className={`toggle-btn ${visualizacao === 'atual' ? 'active' : ''}`} onClick={() => setVisualizacao('atual')}>
                Dia Atual
              </button>
            </div>
          </div>
          
          <div className="dashboard-container">
            <div className="dashboard-card">
              <h5><FaChartPie className="dashboard-icon" /> Progresso no Programa</h5>
              <div className="chart-container">
                <Doughnut data={dadosVisualizacao.progresso} options={chartOptions} />
              </div>
              <p className="chart-description">
                {visualizacao === 'todos' ? `Semana ${semanas} de 12` : `${dadosVisualizacao.progresso.datasets[0].data[0]}% do dia concluído`}
              </p>
            </div>
            
            <div className="dashboard-card">
              <h5><FaChartPie className="dashboard-icon" /> Estado Emocional</h5>
              <div className="chart-container">
                <Doughnut data={dadosVisualizacao.emocoes} options={chartOptions} />
              </div>
              <p className="chart-description">
                {visualizacao === 'todos' ? 'Média de todos os registros' : 'Registros do dia atual'}
              </p>
            </div>
            
            <div className="dashboard-card">
              <h5><FaChartPie className="dashboard-icon" /> Consistência</h5>
              <div className="chart-container">
                <Doughnut data={dadosVisualizacao.consistencia} options={chartOptions} />
              </div>
              <p className="chart-description">
                {visualizacao === 'todos' ? '75% das atividades concluídas (total)' : '85% das atividades concluídas hoje'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

function Alunas() {
  const [alunas, setAlunas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [alunaAtual, setAlunaAtual] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  
  // Estados para busca e filtros
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [semanaMin, setSemanaMin] = useState('');
  const [semanaMax, setSemanaMax] = useState('');
  const [dataInicioMin, setDataInicioMin] = useState('');
  const [dataInicioMax, setDataInicioMax] = useState('');
  const [sortBy, setSortBy] = useState('data_inicio');
  const [sortOrder, setSortOrder] = useState('desc');
  
  // Estados para paginação
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  
  const fetchAlunas = useCallback(async () => {
    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL_USER || 'http://localhost:3031';
      
      const params = new URLSearchParams({
        page: currentPage.toString(),
        limit: itemsPerPage.toString(),
        sortBy,
        sortOrder,
      });
      
      if (searchTerm) params.append('search', searchTerm);
      if (statusFilter) params.append('status', statusFilter);
      if (semanaMin) params.append('semanaMin', semanaMin);
      if (semanaMax) params.append('semanaMax', semanaMax);
      if (dataInicioMin) params.append('dataInicioMin', dataInicioMin);
      if (dataInicioMax) params.append('dataInicioMax', dataInicioMax);
      
      const response = await axios.get(`${apiUrl}/api/users/admin/filtered?${params.toString()}`);
      
      if (response.data && response.data.users) {
        setAlunas(response.data.users);
        setTotal(response.data.pagination.total);
        setTotalPages(response.data.pagination.totalPages);
      } else {
        setAlunas([]);
      }
      
      setLoading(false);
    } catch (error) {
      console.error('Erro ao buscar alunas:', error);
      setError('Não foi possível carregar as alunas. Tente novamente mais tarde.');
      setLoading(false);
    }
  }, [searchTerm, statusFilter, semanaMin, semanaMax, dataInicioMin, dataInicioMax, sortBy, sortOrder, currentPage, itemsPerPage]);
  
  useEffect(() => {
    fetchAlunas();
  }, [fetchAlunas]);
  
  const handleSelectAll = () => {
    if (selectedUsers.length === alunas.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(alunas.map(a => a._id));
    }
  };
  
  const handleSelectUser = (userId) => {
    if (selectedUsers.includes(userId)) {
      setSelectedUsers(selectedUsers.filter(id => id !== userId));
    } else {
      setSelectedUsers([...selectedUsers, userId]);
    }
  };
  
  const handleBatchStatusUpdate = async (status) => {
    if (selectedUsers.length === 0) {
      alert('Selecione pelo menos um usuário');
      return;
    }
    
    if (!window.confirm(`Deseja realmente atualizar o status de ${selectedUsers.length} usuário(s) para "${status}"?`)) {
      return;
    }
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL_USER || 'http://localhost:3031';
      await axios.put(`${apiUrl}/api/users/admin/batch-status`, {
        userIds: selectedUsers,
        status
      });
      
      alert('Status atualizado com sucesso!');
      setSelectedUsers([]);
      fetchAlunas();
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      alert('Erro ao atualizar status');
    }
  };
  
  const formatarData = (dataString) => {
    if (!dataString) return '-';
    const data = new Date(dataString);
    return data.toLocaleDateString('pt-BR');
  };
  
  const calcularDiasNoPrograma = (dataString) => {
    if (!dataString) return 0;
    const dataInicio = new Date(dataString);
    const hoje = new Date();
    const diffTempo = Math.abs(hoje - dataInicio);
    return Math.ceil(diffTempo / (1000 * 60 * 60 * 24));
  };
  
  const getStatusBadge = (status) => {
    const statusMap = {
      ativo: { icon: FaCheckCircle, color: '#28a745', label: 'Ativo' },
      pausado: { icon: FaPauseCircle, color: '#ffc107', label: 'Pausado' },
      inativo: { icon: FaStopCircle, color: '#dc3545', label: 'Inativo' }
    };
    
    const statusInfo = statusMap[status] || statusMap.ativo;
    const Icon = statusInfo.icon;
    
    return (
      <span className={`status-badge status-${status}`} style={{ color: statusInfo.color }}>
        <Icon /> {statusInfo.label}
      </span>
    );
  };
  
  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(field);
      setSortOrder('desc');
    }
  };
  
  const clearFilters = () => {
    setSearchTerm('');
    setStatusFilter('');
    setSemanaMin('');
    setSemanaMax('');
    setDataInicioMin('');
    setDataInicioMax('');
    setCurrentPage(1);
  };
  
  if (loading && alunas.length === 0) {
    return (
      <div className="secao-alunas loading-container">
        <div className="loading-spinner"></div>
        <p>Carregando alunas...</p>
      </div>
    );
  }
  
  if (error && alunas.length === 0) {
    return (
      <div className="secao-alunas error-container">
        <p className="error-message">{error}</p>
        <button className="retry-button" onClick={fetchAlunas}>Tentar novamente</button>
      </div>
    );
  }
  
  return (
    <div className="secao-alunas">
      <div className="alunas-header">
        <h1>Alunas</h1>
        <div className="header-actions">
          <button 
            className={`btn-filter ${showFilters ? 'active' : ''}`}
            onClick={() => setShowFilters(!showFilters)}
          >
            <FaFilter /> Filtros
          </button>
        </div>
      </div>
      
      {/* Barra de busca e filtros */}
      <div className="filters-section">
        <div className="search-bar">
          <FaSearch className="search-icon" />
          <input
            type="text"
            placeholder="Buscar por nome ou email..."
            value={searchTerm}
            onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            className="search-input"
          />
        </div>
        
        {showFilters && (
          <div className="filters-panel">
            <div className="filter-row">
              <div className="filter-group">
                <label>Status:</label>
                <select value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setCurrentPage(1); }}>
                  <option value="">Todos</option>
                  <option value="ativo">Ativo</option>
                  <option value="pausado">Pausado</option>
                  <option value="inativo">Inativo</option>
                </select>
              </div>
              
              <div className="filter-group">
                <label>Semana Mín:</label>
                <input type="number" min="1" max="12" value={semanaMin} onChange={(e) => { setSemanaMin(e.target.value); setCurrentPage(1); }} />
              </div>
              
              <div className="filter-group">
                <label>Semana Máx:</label>
                <input type="number" min="1" max="12" value={semanaMax} onChange={(e) => { setSemanaMax(e.target.value); setCurrentPage(1); }} />
              </div>
              
              <div className="filter-group">
                <label>Data Início Mín:</label>
                <input type="date" value={dataInicioMin} onChange={(e) => { setDataInicioMin(e.target.value); setCurrentPage(1); }} />
              </div>
              
              <div className="filter-group">
                <label>Data Início Máx:</label>
                <input type="date" value={dataInicioMax} onChange={(e) => { setDataInicioMax(e.target.value); setCurrentPage(1); }} />
              </div>
              
              <button className="btn-clear-filters" onClick={clearFilters}>
                Limpar Filtros
              </button>
            </div>
          </div>
        )}
      </div>
      
      {/* Ações em lote */}
      {selectedUsers.length > 0 && (
        <div className="batch-actions">
          <span className="selected-count">{selectedUsers.length} selecionado(s)</span>
          <div className="batch-buttons">
            <button className="btn-batch btn-active" onClick={() => handleBatchStatusUpdate('ativo')}>
              <FaCheckCircle /> Ativar
            </button>
            <button className="btn-batch btn-pause" onClick={() => handleBatchStatusUpdate('pausado')}>
              <FaPauseCircle /> Pausar
            </button>
            <button className="btn-batch btn-inactive" onClick={() => handleBatchStatusUpdate('inativo')}>
              <FaStopCircle /> Desativar
            </button>
            <button className="btn-batch btn-email" onClick={() => alert('Funcionalidade de email em desenvolvimento')}>
              <FaEnvelope /> Enviar Email
            </button>
          </div>
        </div>
      )}
      
      {/* Tabela */}
      {alunas.length === 0 ? (
        <div className="no-alunas-message">
          <p>Nenhuma aluna encontrada com os filtros aplicados.</p>
        </div>
      ) : (
        <>
          <div className="tabela-container">
            <table className="tabela-alunas">
              <thead>
                <tr>
                  <th className="col-checkbox">
                    <button className="btn-select-all" onClick={handleSelectAll}>
                      {selectedUsers.length === alunas.length ? <FaCheckSquare /> : <FaSquare />}
                    </button>
                  </th>
                  <th className="col-status">Status</th>
                  <th className="col-email" onClick={() => handleSort('email')}>
                    Email <FaSort className={`sort-icon ${sortBy === 'email' ? 'active' : ''}`} />
                  </th>
                  <th className="col-nome" onClick={() => handleSort('nome')}>
                    Nome <FaSort className={`sort-icon ${sortBy === 'nome' ? 'active' : ''}`} />
                  </th>
                  <th className="col-data" onClick={() => handleSort('data_inicio')}>
                    Início <FaSort className={`sort-icon ${sortBy === 'data_inicio' ? 'active' : ''}`} />
                  </th>
                  <th className="col-semana">Semana</th>
                  <th className="col-dias">Dias</th>
                  <th className="col-peso">Peso</th>
                  <th className="col-altura">Altura</th>
                  <th className="col-telefone">Telefone</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {alunas.map((aluna) => (
                  <tr key={aluna._id} className={`linha-aluna ${selectedUsers.includes(aluna._id) ? 'selected' : ''}`}>
                    <td className="col-checkbox">
                      <button className="btn-select" onClick={() => handleSelectUser(aluna._id)}>
                        {selectedUsers.includes(aluna._id) ? <FaCheckSquare /> : <FaSquare />}
                      </button>
                    </td>
                    <td className="col-status">{getStatusBadge(aluna.status || 'ativo')}</td>
                    <td className="col-email">{aluna.email}</td>
                    <td className="col-nome">{aluna.nome || '-'}</td>
                    <td className="col-data">{formatarData(aluna.data_inicio)}</td>
                    <td className="col-semana">Sem {aluna.semanaAtual || Math.ceil(calcularDiasNoPrograma(aluna.data_inicio) / 7)}</td>
                    <td className="col-dias">{calcularDiasNoPrograma(aluna.data_inicio)}</td>
                    <td className="col-peso">{aluna.peso ? `${aluna.peso} kg` : '-'}</td>
                    <td className="col-altura">{aluna.altura ? `${aluna.altura} cm` : '-'}</td>
                    <td className="col-telefone">{aluna.telefone || '-'}</td>
                    <td className="col-acoes">
                      <button className="btn-ver-perfil" onClick={() => setAlunaAtual(aluna)}>
                        Ver Perfil
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {/* Paginação */}
          <div className="pagination">
            <div className="pagination-info">
              Mostrando {((currentPage - 1) * itemsPerPage) + 1} a {Math.min(currentPage * itemsPerPage, total)} de {total} alunas
            </div>
            <div className="pagination-controls">
              <button 
                className="btn-pagination" 
                onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                disabled={currentPage === 1}
              >
                <FaChevronLeft /> Anterior
              </button>
              <span className="pagination-pages">
                Página {currentPage} de {totalPages}
              </span>
              <button 
                className="btn-pagination" 
                onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                disabled={currentPage === totalPages}
              >
                Próxima <FaChevronRight />
              </button>
              <select 
                value={itemsPerPage} 
                onChange={(e) => { setItemsPerPage(parseInt(e.target.value)); setCurrentPage(1); }}
                className="items-per-page"
              >
                <option value="10">10 por página</option>
                <option value="25">25 por página</option>
                <option value="50">50 por página</option>
                <option value="100">100 por página</option>
              </select>
            </div>
          </div>
        </>
      )}
      
      {/* Modal de perfil completo */}
      {alunaAtual && (
        <Modal 
          aluna={alunaAtual} 
          onClose={() => setAlunaAtual(null)}
          onNoteAdded={fetchAlunas}
          onNoteRemoved={fetchAlunas}
        />
      )}
    </div>
  );
}

export default Alunas;
